export default __webpack_public_path__ + "static/media/Track.256.a030e75f.png";